<span
    class="app-popover-trigger"
    cdkOverlayOrigin
    #overlayOrigin="cdkOverlayOrigin"
    [class.app-popover-trigger--clickable]="trigger === 'click' && !disabled"
    [class.app-popover-trigger--active]="isOpen"
    (click)="onTriggerClick($event)"
    (mouseenter)="onTriggerMouseEnter()"
    (mouseleave)="onTriggerMouseLeave()">
    <ng-content />
</span>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayHasBackdrop]="trigger === 'click'"
    cdkConnectedOverlayBackdropClass="app-popover-backdrop"
    (backdropClick)="close()"
    (detach)="close()">
    <div
        [class]="panelClasses.join(' ')"
        role="dialog"
        (mouseenter)="onPanelMouseEnter()"
        (mouseleave)="onPanelMouseLeave()"
        (click)="$event.stopPropagation()">
        @if (bodyTemplate) {
        <ng-container *ngTemplateOutlet="bodyTemplate" />
        } @else if (bodyComponent) {
        <ng-container *ngComponentOutlet="bodyComponent; inputs: bodyInputs ?? {}" />
        } @else {
        <p class="app-popover-panel__text">{{ content }}</p>
        }
    </div>
</ng-template>
